<template>
  <div>
    <v-card-text class="ml-5"
      >จำนวนทั้งหมด {{ surveylist.length }} แบบทดสอบ</v-card-text
    >
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="grey lighten-2">เพิ่ม Question </v-card-title>
        <v-card-text>
          <v-card flat>
            <v-card-text>
              <v-form ref="form">
                <v-text-field
                  v-model="connect"
                  label="จำนวนคำถาม"
                  outlined
                  dense
                  type="number"
                  min="1"
                  max="10"
                  :rules="[
                    $store.getters.NumberRangeRule({
                      amount: connect,
                      min: 1,
                      max: 10,
                    }),
                  ]"
                  @keydown.enter.prevent
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined @click="dialog = false">
                ยกเลิก
              </v-btn>
              <v-btn color="primary" @click="PreQuestion"> บันทึก </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container>
      <v-card
        class="d-flex justify-start flex-wrap"
        color="transparent"
        flat
        tile
      >
        <v-card
          class="mb-12 mx-6 rounded-xl"
          width="300"
          v-for="(survey, i) in surveylist"
          :key="i"
          :color="survey.surveyStatus ? undefined : 'grey lighten-3'"
          @click="
            QuestionRoute(
              survey,
              survey.surveyStatus && !trial ? 'overview' : 'question'
            )
          "
        >
          <v-img
            :src="
              survey.surveyCoverPic
                ? survey.surveyCoverPic
                : 'https://chatme04.chatme.co.th/CMStorage/noimg_1627009085040.jpeg'
            "
            max-height="130"
            :style="{
              filter: survey.surveyStatus ? undefined : 'grayscale(100%)',
            }"
          ></v-img>
          <v-card-title>
            <span
              style="
                font-size: 16px;
                word-break: break-word;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2; /* number of lines to show */
                line-clamp: 2;
                -webkit-box-orient: vertical;
              "
            >
              {{ survey.surveyName }}
            </span>
          </v-card-title>
          <v-card-subtitle class="pb-0">
            <span
              class="d-inline-block text-truncate"
              style="max-width: 260px; word-break: break-word"
            >
              {{ survey.surveyDetail }}
            </span>
          </v-card-subtitle>
          <v-card-actions
            class="py-0"
            :class="[survey.surveyDetail ? undefined : 'mt-2']"
            style="height: 35px"
          >
            <v-spacer></v-spacer>
            <!-- <v-switch
              v-model="survey.surveyStatus"
              :color="SPermission.enableControl ? '#033666' : 'grey'"
              :disabled="!SPermission.enableControl"
              @click.stop="ToggleSurvey(survey, i)"
            ></v-switch> -->
            <!-- <PopupEditSurvey
              v-if="!survey.surveyStatus && SPermission.update"
              :trial="trial"
              :survey="survey"
            /> -->
            <v-tooltip v-if="survey.surveyStatus" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="pink"
                  class="mx-2"
                  icon
                  small
                  @click.stop="GenerateWebform(survey.surveyID)"
                  ><v-icon>link</v-icon></v-btn
                >
              </template>
              <span>Webform URL</span>
            </v-tooltip>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" small>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  :disabled="!SPermission.create || !limitSurvey"
                  @click="CopySurvey(survey.surveyID, survey)"
                >
                  <v-icon
                    :disabled="!SPermission.create || !limitSurvey"
                    class="mx-2"
                    color="#30B79E"
                    >mdi-content-copy</v-icon
                  >คัดลอกแบบสอบถาม
                </v-list-item>
                <v-list-item
                  @click="
                    $store.getters.CopyText(survey.surveyID), CopySurveyID()
                  "
                >
                  <v-icon class="mx-2" color="warning">vpn_key</v-icon> คัดลอก
                  Survey ID
                </v-list-item>

                <!-- <v-list-item
                  :disabled="!SPermission.update"
                  @click="QuestionRoute(survey, 'setting')"
                >
                  <v-icon :disabled="!SPermission.update" class="mx-2"
                    >settings</v-icon
                  >
                  ตั้งค่า
                </v-list-item>
                <v-list-item
                  :disabled="!SPermission.delete"
                  @click.stop="DeleteSurvey(i)"
                >
                  <v-icon
                    :disabled="!SPermission.delete"
                    class="mx-2"
                    color="#DE4F3B"
                    >mdi-trash-can</v-icon
                  >
                  ลบแบบสอบถาม
                </v-list-item> -->
              </v-list>
            </v-menu>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-container>
    <v-dialog v-model="dwebform" @click:outside="copied = false" width="500">
      <v-card>
        <v-card-title> Webform URL </v-card-title>
        <v-card-text> คัดลอก link นี้เพื่อทำการเริ่มทำแบบทดสอบ </v-card-text>
        <v-card-text class="d-flex align-center">
          <v-text-field
            hide-details
            outlined
            ref="link"
            :label="copied ? 'Link copied' : 'Click to copy link'"
            class="pa-4"
            readonly
            :value="url"
            @click="copy"
          ></v-text-field>
          <v-btn color="#1184bd" icon
            ><v-icon class="mx-3" @click="copy">content_copy</v-icon></v-btn
          >
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="(dwebform = false), (copied = false)"
          >
            ปิดหน้าต่าง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="2000">
      คัดลอกเรียบร้อย
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Swal from "sweetalert2";
// import PopupEditSurvey from "./PopupEditSurvey";
export default {
  // components: { PopupEditSurvey },
  props: ["surveylist", "trial", "limitSurvey"],
  data() {
    return {
      dialog: false,
      dwebform: false,
      survey_selected: {},
      connect: 1,
      end: 1,
      url: "",
      copied: false,
      snackbar: false,
    };
  },
  computed: {
    SPermission() {
      // if (this.trial) {
      //   return {
      //     enableControl: true,
      //     create: true,
      //     update: true,
      //     delete: true,
      //   };
      // }
      // return this.$store.state.user_permission.survey;
      return {
        enableControl: true,
        create: true,
        update: true,
        delete: true,
      };
    },
  },
  methods: {
    NotAllowAlert(allowUser) {
      let text = "ระบบมีปัญหา กรุณาติดต่อทีมงาน";
      if (allowUser.data.typeUser === "ExpiredUser") {
        text = `Package ของคุณหมดอายุ<br>กรุณาติดต่อทีมงานเพื่อขอต่ออายุบริการได้ที่<br><a style="color: #0093cc;"
                      href='tel:0935781416'
                      >093-5781416</a
                    >, <a style="color: #0093cc;"
                    href='tel:0655214474'
                    >065-5214474</a
                  >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >
`;
      } else if (allowUser.data.typeUser === "NotStartUser") {
        text = `บัญชีของคุณยังไม่สามารถใช้งานได้ จะสามารถใช้งานได้ตั้งแต่วันที่ ${this.$store.getters.dateConvertVeryShort(
          allowUser.data.startedDate
        )} เป็นต้นไป<br>สอบถามข้อมูลเพิ่มเติมได้ที่<br><a style="color: #0093cc;"
                      href='tel:0935781416'
                      >093-5781416</a
                    >, <a style="color: #0093cc;"
                    href='tel:0655214474'
                    >065-5214474</a
                  >, <a style="color: #033666;"
            href='tel:0655214459'
            >065-5214459</a
          >
`;
      }
      Swal.fire({
        html: text,
        icon: "warning",
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: "#0093cc",
        confirmButtonText: "ตกลง",
      });
    },
    PreQuestion() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("AddPrequestion", {
            surveyID: this.survey_selected.surveyID,
            connect: this.connect,
            fail: 1,
            end: 1,
          })
          .then(() => {
            // console.log("action success");
            this.QuestionRoute(this.survey_selected, "question");
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถเพิ่มคำถามได้ได้",
              title: "",
            }).then(() => {
              this.dialog = false;
              this.$store.dispatch("getSurvey");
            });
          });
      }
    },
    QuestionRoute(survey, route) {
      this.$store.state.surveystatus = survey.surveyStatus;
      this.$store.dispatch("checkPackage").then((allowUser) => {
        // console.log(allowUser);
        if (
          allowUser.data.typeUser === "AvailableUser" ||
          allowUser.data.typeUser === "MemberUser"
        ) {
          let api = {
            method: "get",
            url: `${process.env.VUE_APP_API}/manageSurvey/permission/${survey.surveyID}`,
            data: {},
          };
          this.$axios({
            ...api,
            headers: {
              authorization:
                "Bearer " +
                this.$cookies.get(
                  process.env.VUE_APP_CM_AUTH_COOKIE + "_token"
                ),
            },
          })
            .then((resp_role) => {
              this.$store
                .dispatch("getQuestionLabel", survey)
                .then((response) => {
                  if (response.prequestion) {
                    this.dialog = true;
                    this.survey_selected = response.survey;
                  } else {
                    let routeName = route;
                    if (resp_role.data.permission) {
                      if (Object.keys(resp_role.data.permission).length === 0) {
                        this.$store.commit("UpdateUserPermission", {
                          limitSurvey: 1,
                          survey: {
                            enableControl: false,
                            create: false,
                            update: false,
                            delete: false,
                          },
                          question: {
                            create: false,
                            update: false,
                            delete: false,
                          },
                          report: {
                            view: false,
                            download: false,
                          },
                          account: {
                            view: false,
                            update: false,
                            delete: false,
                            createInvite: false,
                            createRole: false,
                          },
                        });
                        this.$router.push({
                          name: "question",
                          params: {
                            surveyID: response.survey.surveyID,
                            surveyName: response.survey.surveyName,
                          },
                        });
                      } else {
                        this.$store.commit(
                          "UpdateUserPermission",
                          resp_role.data
                        );
                        let report_view = resp_role.data.permission.report.view;
                        if (!report_view) {
                          routeName = "question";
                        }
                        this.$router.push({
                          name: routeName,
                          params: {
                            surveyID: response.survey.surveyID,
                            surveyName: response.survey.surveyName,
                          },
                        });
                      }
                    }
                  }
                });
            })
            .catch((err) => {
              if (!err.response.data.auth) {
                if (err.response.data.message === "Token not match.") {
                  this.$store.commit("Logout");
                  Swal.fire({
                    html: `พบการ login ซ้ำ`,
                    icon: "warning",
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    confirmButtonColor: "#0093cc",
                    confirmButtonText: "รับทราบ",
                  });
                } else {
                  let errMsg = "คุณไม่สามารถเข้าดู survey นี้ได้";
                  Swal.fire({
                    icon: "error",
                    text: errMsg,
                    title: "",
                  }).then(() => {
                    this.$store.dispatch("getSurvey");
                  });
                }
              } else {
                if (err.response.status === 500) {
                  let errMsg = "คุณไม่สามารถเข้าดู survey นี้ได้";
                  Swal.fire({
                    icon: "error",
                    text: errMsg,
                    title: "",
                  }).then(() => {
                    this.$store.dispatch("getSurvey");
                  });
                } else {
                  this.$router.push({
                    name: "question",
                    params: {
                      surveyID: survey.surveyID,
                      surveyName: survey.surveyName,
                    },
                  });
                }
              }
            });
        } else {
          this.NotAllowAlert(allowUser);
        }
      });
    },
    ToggleSurvey(survey, i) {
      this.$store.dispatch("getQuestionLabel", survey).then((response) => {
        if (response.prequestion) {
          this.dialog = true;
          this.survey_selected = response.survey;
          this.$store.dispatch("getSurvey");
        } else {
          Swal.fire({
            title: `ยืนยันการ${
              !this.surveylist[i].surveyStatus ? "ปิด" : "เปิด"
            } "${this.surveylist[i].surveyName}"`,
            text: "",
            icon: "warning",
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          }).then((result) => {
            if (result.isConfirmed) {
              this.$store
                .dispatch("UpdateSurveyStatus", this.surveylist[i])
                .then(() => {
                  Swal.fire({
                    icon: "success",
                    text: `${
                      !this.surveylist[i].surveyStatus ? "ปิด" : "เปิด"
                    } "${this.surveylist[i].surveyName}" เรียบร้อยแล้ว`,
                    title: "",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(() => {
                    this.$store.dispatch("getSurvey");
                  });
                })
                .catch((err) => {
                  let errMsg =
                    err.data.message === "Permission Denied"
                      ? "คุณไม่มีสิทธิ์เข้าถึงการเปิดหรือปิด survey"
                      : "ไม่สามารถแก้ไขได้";
                  Swal.fire({
                    icon: "error",
                    text: errMsg,
                    title: "",
                  }).then(() => {
                    this.$store.dispatch("getSurvey");
                    this.$store.commit("ToggleLoading");
                    if (errMsg.data.message === "Permission Denied") {
                      this.$store
                        .dispatch(
                          "getQuestionPermission",
                          this.$route.params.surveyID
                        )
                        .then(() => {
                          this.$router.push({
                            name: "question",
                          });
                        });
                    }
                  });
                });
            } else {
              this.$store.dispatch("getSurvey");
            }
          });
        }
      });
    },
    DeleteSurvey(i) {
      Swal.fire({
        title: `ยืนยันการลบ "${this.surveylist[i].surveyName}"`,
        text: "",
        icon: "warning",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("DeleteSurvey", this.surveylist[i])
            .then(() => {
              Swal.fire({
                icon: "success",
                text: `ลบ "${this.surveylist[i].surveyName}" เรียบร้อยแล้ว`,
                title: "",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$store.dispatch("getSurvey");
              });
            })
            .catch((err) => {
              let errMsg =
                err.data.message === "Permission Denied"
                  ? "คุณไม่มีสิทธิ์ลบ survey"
                  : "ไม่สามารถลบได้";
              Swal.fire({
                icon: "error",
                text: errMsg,
                title: "",
              }).then(() => {
                this.$store.dispatch("getSurvey");
                this.$store.commit("ToggleLoading");
                if (errMsg.data.message === "Permission Denied") {
                  this.$store
                    .dispatch(
                      "getQuestionPermission",
                      this.$route.params.surveyID
                    )
                    .then(() => {
                      this.$router.push({
                        name: "question",
                      });
                    });
                }
              });
            });
        } else {
          this.$store.dispatch("getSurvey");
        }
      });
    },
    CopySurveyID() {
      Swal.fire({
        icon: "success",
        text: `คัดลอก Survey ID สำเร็จ`,
        title: "",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    CopySurvey(surveyID, survey) {
      this.$store.dispatch("getQuestionLabel", survey).then((response) => {
        if (response.prequestion) {
          this.dialog = true;
          this.survey_selected = response.survey;
        } else {
          this.$store
            .dispatch("CopySurvey", surveyID)
            .then(() => {
              Swal.fire({
                icon: "success",
                text: `คัดลอกเรียบร้อยแล้ว`,
                title: "",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$store.dispatch("getSurvey");
              });
            })
            .catch((err) => {
              let errMsg =
                err.data.message === "Permission Denied"
                  ? "คุณไม่มีสิทธิ์ copy survey"
                  : "ไม่สามารถ copy survey ได้";
              Swal.fire({
                icon: "error",
                text: errMsg,
                title: "",
              }).then(() => {
                this.$store.dispatch("getSurvey");
                this.$store.commit("ToggleLoading");
                if (errMsg.data.message === "Permission Denied") {
                  this.$store
                    .dispatch(
                      "getQuestionPermission",
                      this.$route.params.surveyID
                    )
                    .then(() => {
                      this.$router.push({
                        name: "question",
                      });
                    });
                }
              });
            });
        }
      });
    },
    copy() {
      const markup = this.$refs.link;
      markup.focus();
      document.execCommand("selectAll", false, null);
      this.copied = document.execCommand("copy");
      this.snackbar = true;
    },
    GenerateWebform(surveyID) {
      this.url = `${window.location.href}startform?surveyID=${surveyID}`;
      this.$store.getters.CopyText(this.url);
      this.snackbar = true;
      // this.dwebform = true;
    },
  },
};
</script>

<style scoped>
.btn:hover {
  position: relative;
  z-index: 1;
  border: 2px solid #0d8eee !important;
}
</style>
